//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FabricSearch from "@/components/q-fabric-search.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";

export default {
    components: {
        FabricSearch,
        AQAvatar,
        AQBadge,
        AQChip,
        AQTooltip,
        AQCheckbox
    },
    props: {
        /*
         exemple [{ label: '', value: '', avatarProps: {type, isDisabled, isEditable}, leftIcon: {name: "edit", size: '16px'},
         tooltip: {tooltipContent, direction} }]
         avatar,badge,chip, tooltip, leftIcon, rightIcon, is an Object with there specific props
         if you want the item from within from within the menu to be disabled, send inside the options object itemDisabled: true
         if you want a description/sub-label send in the options object description: "string"
        */
        options: {
            type: Array,
            required: true,
            default: () => []
        },
        value: { type: Array, required: true, default: () => [] },
        innerMenu: { type: Boolean, default: false }, // used for dropdown, has specific position
        addSearch: { type: Boolean, default: false }, // show search field in options container
        disable: { type: Boolean, default: false }, // disable popover (popover won`t be opened)
        fitParentContainer: { type: Boolean, default: false }, // options container width = parent width
        hasAvatar: { type: Boolean, default: false }, // show AQAvatar on the left side - option
        resetSelectedData: { type: Boolean, default: false }, // reset selected option (s)
        hasCheckbox: { type: Boolean, default: false }, // show checkbox
        separator: { type: Boolean, default: false }, // separator line between items
        error: { type: Boolean, default: false }, // set error border
        isMultiselect: { type: Boolean, default: false }, // enable multiple selection
        avatarRounded: { type: Boolean, default: true }, // if avatar exist
        hasPagination: { type: Boolean, default: false }, // for search with pagination in be
        conditionalDDL: { type: Boolean, default: false }, // for reports operators in data model container
        clearableChip: { type: Boolean, default: false }, // prop to sent to AQchip for remove inner menu chips
        chipDeleted: { type: Boolean, default: false }, // prop emited from AQDropdown to refresh initialMultipleValues,
        popoverAnchorPosition: { type: String, default: null }, // prop used for anchor popover position
        popoverSelfPosition: { type: String, default: null }, // prop used for self popover position
        maxHeight: { type: String, default: "" }, // The maximum height of the menu; Size in CSS units, including unit name
        maxWidth: { type: String, default: "" }, // The maximum width of the menu; Size in CSS units, including unit name
        minWidth: { type: String, default: "" }, // The minimum width of the menu; Size in CSS units, including unit name
        square: { type: Boolean, default: false }, // Forces content to have squared borders
        persistent: { type: Boolean, default: false }, // Allows the menu to not be dismissed by a click/tap outside of the menu or by hitting the ESC key
        cover: { type: Boolean, default: false }, // Allows the menu to cover its target. When used, the 'self' and 'fit' props are no longer effective
        transitionHide: { type: String, default: "fade" }, // One of Quasar's embedded transitions
        transitionShow: { type: String, default: "fade" }, // One of Quasar's embedded transitions,
        noFocus: { type: Boolean, default: false }, // (Accessibility) When Menu gets shown, do not switch focus on it
        noRefocus: { type: Boolean, default: false }, // (Accessibility) When Menu gets hidden, do not refocus on the DOM element that previously had focus
        separateClosePopup: {
            type: Boolean,
            default: false
        }, // Separate from parent menu, marking it as a separate closing point for v-close-popup (without this, chained menus close all together),
        zIndex: { type: Number, default: 9999 }, // use this prop with the desired value if the menu is displayed under another element
        keepOneOptionSelected: { type: Boolean, default: false },
        disabledOptionsList: { type: Array, default: () => [] }, // disable options , ex: ["value", "value1", . . . ],
        titleMenu: { type: Boolean, default: false },
        paddingInnerMenu: { type: Boolean, default: false }, // aqdropdown have a rounded border,
        fromAccountMenu: { type: Boolean, default: false }, // used JUST FOR ACCOUNT MENU,
        mobilePadding: { type: Boolean, default: false },
        fromDropdown: { type: Boolean, default: false }
    },
    data() {
        return {
            initialMultipleSelected: null,
            canTooltip: false,
            searchValue: "",
            filteredItems: [],
            filteredInnerItems: [],
            multipleSelectedElements: [],
            deSelected: false
        };
    },
    computed: {
        setMaxWidth() {
            return this.fitParentContainer ? "0px" : (this.maxWidth || "auto");
        },
        popoverAnchorPositionComputed() {
            let anchor = "";
            if (this.popoverAnchorPosition) {
                anchor = this.popoverAnchorPosition;
            } else {
                anchor = this.innerMenu ? "bottom right" : "bottom middle";
            }
            return anchor;
        },
        popoverSelfPositionComputed() {
            let self = "";
            if (this.popoverSelfPosition) {
                self = this.popoverSelfPosition;
            } else {
                self = this.innerMenu ? "bottom left" : "top middle";
            }
            return self;
        }
    },
    watch: {
        value: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.multipleSelectedElements = newVal;
                }
                // set the initalMultipleSelected, otherwise will be null and on selection the removeChip event won`t be trigger
                if (newVal && !oldVal && !this.initialMultipleSelected) {
                    this.initialMultipleSelected = JSON.parse(
                        JSON.stringify(newVal)
                    );
                }
                // something for the deselect event to remove roundChip wip
            },
            immediate: true
        },
        options: {
            handler(newValue) {
                if (newValue && newValue.length) {
                    if (this.innerMenu) {
                        this.filteredInnerItems = newValue;
                    } else {
                        this.filteredItems = newValue;
                    }
                    const newInstancesSelectedElements = [];
                    if (this.multipleSelectedElements && this.multipleSelectedElements.length) {
                        this.value.forEach(elem => {
                            const isExists = this.filteredItems.find(item => elem.hasOwnProperty("value") && (elem.value === item.value));
                            if (isExists) {
                                newInstancesSelectedElements.push(isExists);
                            }
                        });
                        if (newInstancesSelectedElements.length) {
                            this.multipleSelectedElements = [...newInstancesSelectedElements];
                        }
                    }
                } else {
                    this.filteredItems = [];
                }
            },
            immediate: true
        },
        chipDeleted: {
            handler(newVal) {
                if (newVal) {
                    this.initialMultipleSelected = JSON.parse(JSON.stringify(this.multipleSelectedElements));
                }
            }
        },
        resetSelectedData: {
            handler(newValue) {
                if (newValue) {
                    this.multipleSelectedElements = [];
                }
            },
            immediate: true
        }
    },
    methods: {
        // innner menu chip type also used in AQdropdown
        setChipType(item) {
            let type = "default";
            if (item.avatarProps) {
                if (
                    item.avatarProps.type === "system"
                    || item.avatarProps.type === "platform"
                    || item.avatarProps.type === "applicationSpecific"
                    || item.avatarProps.type === "externalGroup"
                ) {
                    type = "group";
                } else {
                    type = "user";
                }
            }
            return type;
        },
        emitDeleteChip(evt) {
            this.$emit("deleteInnerChip", evt);
        },
        checkBoxClicked(item) {
            if (!this.isMultiselect && this.$refs.popoverCustomSelect && !this.disabledOptionsList.includes(item.value)) {
                this.$refs.popoverCustomSelect.hide();
            }
        },
        setReadonly(item) {
            let isReadonly = false;
            if (!this.isMultiselect && this.multipleSelectedElements.length) {
                if (this.multipleSelectedElements.indexOf(item) !== -1) {
                    isReadonly = true;
                }
            }
            return isReadonly;
        },
        setTooltipProps(item, content) {
            let result;
            if (content) {
                if (item.tooltipProps && item.tooltipProps.tooltipContent) {
                    result = item.tooltipProps.tooltipContent;
                } else result = "";
            } else if (item.tooltipProps && item.tooltipProps.direction) {
                result = item.tooltipProps.direction;
            } else {
                result = "top";
            }
            return result;
        },
        showTooltip(item) {
            return (
                this.canTooltip
                && item.tooltipProps
                && Object.keys(item.tooltipProps).length
            );
        },
        searchItems() {
            const lowerCaseValue = this.searchValue ? this.searchValue.toLowerCase() : "";
            if (this.hasPagination) {
                this.$emit("searchValue", lowerCaseValue);
            } else {
                let filterdArray = [];
                filterdArray = this.options.filter(item => (item.label ? item.label.toLowerCase().includes(lowerCaseValue) : false));
                if (this.innerMenu) {
                    this.filteredInnerItems = filterdArray.length
                        ? filterdArray
                        : [{ label: this.$t("applicationPermissions.noResultsFound"), itemDisabled: true }];
                } else {
                    this.filteredItems = filterdArray.length ? filterdArray : [{ label: this.$t("applicationPermissions.noResultsFound"), itemDisabled: true }];
                }
            }
        },
        propsForAvatar(item) {
            return {
                type: item.avatarProps.type || "userPlatform",
                isEditable: item.avatarProps.isEditable || item.isEditable || false,
                customAvatar: item.avatarProps.customAvatar || "",
                rounded: this.avatarRounded,
                avatarDisabled: item.avatarProps.avatarDisabled || false,
                hasUserNotification: item.hasUserNotification || false,
                size: item.avatarProps.size || 24 // default avatar size in dropdown
            };
        },
        propsForBadge(item) {
            return {
                badgeText: item.badgeProps.badgeText || "",
                badgeColor: item.badgeProps.badgeColor || "",
                badgeType: item.badgeProps.badgeType || "string",
                fontSize: item.badgeProps.fontSize || 10
            };
        },
        propsForChip(item) {
            return {
                type: item.chipProps.type || "default",
                content: item.chipProps.content || null,
                innerContent: item.chipProps.innerContent || ""
            };
        },
        toggleIcon(show) {
            if (show) {
                this.canTooltip = true;
                if (this.resetSelectedData) {
                    this.multipleSelectedElements = [];
                }
                this.initialMultipleSelected = JSON.parse(JSON.stringify(this.multipleSelectedElements));
                this.$emit("show");
            } else {
                this.canTooltip = false;
                this.$emit("hide");
                this.searchValue = "";
                if (this.innerMenu) {
                    this.filteredInnerItems = this.options;
                } else {
                    this.filteredItems = this.options;
                }
            }
        },
        beforeShow(event) {
            this.$emit("beforeShow", event);
        },
        beforeHide(event) {
            this.$emit("beforeHide", event);
        },
        escapeKey(event) {
            this.$emit("escapeKey", event);
        },
        selectItem(item) {
            const selectedValues = [];
            let allItems = this.multipleSelectedElements;
            if (this.keepOneOptionSelected && !this.isMultiselect && !this.multipleSelectedElements.length
                && this.value && this.value.length) {
                this.multipleSelectedElements = this.value;
                this.$refs.popoverCustomSelect.hide();
            } else {
                if (this.value && this.value.length) {
                    const ids = new Set(this.multipleSelectedElements.map(entry => entry.value));
                    allItems = [...this.value.filter(elem => !ids.has(elem.value)), ...this.multipleSelectedElements];
                }

                if (
                    this.initialMultipleSelected
                    && this.initialMultipleSelected.length
                        > this.multipleSelectedElements.length
                ) {
                    this.$emit("deSelect", item);
                    const deselectIndex = allItems.findIndex(elem => elem.value === item.value);
                    allItems.splice(deselectIndex, 1);
                }
                if (allItems.length && this.isMultiselect) {
                    allItems.forEach(elem => {
                        selectedValues.push(elem);
                    });
                    this.$emit("input", selectedValues);
                    this.$emit("selected", selectedValues);
                    this.initialMultipleSelected = JSON.parse(
                        JSON.stringify(allItems)
                    );
                } else if (
                    this.multipleSelectedElements.length
                    && !this.isMultiselect
                ) {
                    selectedValues.push(
                        this.multipleSelectedElements[
                            this.multipleSelectedElements.length - 1
                        ]
                    );
                    this.multipleSelectedElements = selectedValues;
                    this.$emit("input", selectedValues);
                    this.$emit("selected", selectedValues);
                } else {
                    this.$emit("deSelect", item);
                    this.$emit("input", []);
                    this.$emit("selected", []);
                }
                if (!this.isMultiselect) {
                    this.$refs.popoverCustomSelect.hide();
                }
            }
        }
    }
};
